<template>

	<div>
    <div class="my-exam">
      <router-link class="my-exam__aa" to="/user/myClassroom">我的班级</router-link>
      <router-link class="my-exam__a" to="/user/myCourse">我的课程</router-link>
      <!-- <router-link class="my-exam__a" to="/user/myExam">练习中心</router-link> -->
    </div>
    <ks-page-scroll-container :page="page" :page-count="pageCount" @page-change="getMyRoomList" style="padding:0 14px" v-if="list.length">
      <div class="mylist" v-for="(item,index) in list" :key="item.id" @click="getMyClassroomDetail(index,item.get_viewurl)">
        <div class="mylist-content">
            <div class="mylist-content__title">{{item.title}}</div>
            <!-- <div class="mylist-content__vtitle">课后作业</div> -->
            <div class="mylist-content__statistical">已学习<span class="mylist-content__statistical__span"> {{item.has_coursecount}} </span>门/共{{item.coursecount}}门</div>
            <van-progress class="mylist-content__progress" :show-pivot="false" color="#f44" :percentage="item.has_learnpercent*100"/>
        </div>
      </div>

    </ks-page-scroll-container>
    <div class="ks-empty" v-else-if="loaded">
      <img class="ks-empty__img" src="@/assets/user/tips.png">
      暂无数据
    </div>
  </div>

</template>
<script>
	import {GetMyRoomList} from '@/apis/user'
export default{
  name:'MyClassroom',
  data(){
    return {
      loaded:false,
      list:[],
			page:1,
			pageCount:null,
    }
  },
	methods: {
		getMyRoomList(p=1){//获取班级列表
			this.show2 = true
			if(p==1){
				this.list = []
			}
			GetMyRoomList({
				page:p,
				pagesize:1
			}).then(res=>{
				this.list = this.list.concat(res.data)
				this.list.has_learnpercent = Number(this.list.has_learnpercent)
				this.pageCount = res.pagecount
				this.page = p
        this.loaded = true
			})
		},
		getMyClassroomDetail(index,url){
			localStorage.classroomDetail = JSON.stringify(this.list[index])
			this.$router.push(url)
		}
	},
	created(){
		this.getMyRoomList()
	},
  activated(){
    document.tilte = '我的班级'
  }
}
</script>
<style scoped>
    .app{
      background-color:#F2F3F5 ;
    }
    .middlep{
      background-color:#fff;
      width: 100%;
      height:180px;
      margin-top:6px;
      border-radius: 10px;
    }
    .my-exam{
      height: 44px;
      background-color: #fff;
    }
    .my-exam__a{
      font-size: 16px;
      margin:0 10px 0 20px;
      line-height:40px;
      font-weight:bolder;
      font-family:PingFang-SC-Bold;
      color:rgba(51,51,51,1);
      margin-top:14.5px;

    }
    .my-exam__aa{
       font-size: 16px;
      margin:0 10px 0 20px;
      font-weight:bolder;
      font-family:PingFang-SC-Bold;
      color:rgba(251,110,82,1);
    }
    .mylist{
      margin-top: 10px;
      background-color: #fff;
      width: 100%;
      height: 100px;
      border-radius: 10px;
    }
    .mylist-content{
      padding:15px;
    }
    .mylist-content__title{
      font-size:15px;
      float:left;
      font-weight:bold;
    }
    .mylist-content__vtitle{
      font-size:13px;
      float:right;
      margin-top:2.7px;
    }
    .mylist-content__statistical{
      margin-top:30px;
      clear: both;
      font-size:13px;
      color:rgba(153,153,153,1);
    }
    .mylist-content__progress{
      margin-top: 10px;
    }
    .van-progress {
    height: 5px;
    position: relative;
    border-radius: 5px;
    background: #fddcdc;
    }
    .mylist-content__statistical__span{
      color: #F45050;
      font-size:13px;
    }
    .ks-empty__img{
      margin-left: 4px;
      position:absolute;
      top: 16px;
      height: 50px;
    }

</style>





// WEBPACK FOOTER //
// src/pages/user/MyClassroom.vue